// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]7.1.1-11976(291c91dff6)-C17/02/2026-16:26:39-B17/02/2026-16:32:46' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]7.1.1-11976(291c91dff6)-C17/02/2026-16:26:39-B17/02/2026-16:32:46",
  branch: "production",
  latestTag: "7.1.1",
  revCount: "11976",
  shortHash: "291c91dff6",
  longHash: "291c91dff6478e1a919248d0dc99eb33794e351e",
  dateCommit: "17/02/2026-16:26:39",
  dateBuild: "17/02/2026-16:32:46",
  buildType: "Ansible",
  } ;
